import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */

    mandatoryValidationId: {
        id: 'fnol.bi.sasria-business-interruption.mandatoryValidationId',
        defaultMessage: 'Mandatory field validation failed'
    },
    haveLossEstimateMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.haveLossEstimateMandatoryMessage',
        defaultMessage: 'Missing required field "Do you have a Loss Estimate?"'
    },
    lossEstimateMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.lossEstimateMandatoryMessage',
        defaultMessage: 'Missing required field "Loss Estimate"'
    },
    sumInsuredMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.sumInsuredMandatoryMessage',
        defaultMessage: 'Missing required field "Sum Insured"'
    },
    coverTypeMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.coverTypeMandatoryMessage',
        defaultMessage: 'Missing required field "Cover Type"'
    },
    indemnityPeriodMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.indemnityPeriodMandatoryMessage',
        defaultMessage: 'Missing required field "Indemnity Period"'
    },
    materialDamageMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.materialDamageMandatoryMessage',
        defaultMessage: 'Missing required field "Material Damage"'
    },
    relatedClaimMandatoryMessage: {
        id: 'fnol.bi.sasria-business-interruption.relatedClaimMandatoryMessage',
        defaultMessage: 'Missing required field "Related Claim"'
    },

    fieldValidationId: {
        id: 'fnol.bi.sasria-business-interruption.fieldValidationId',
        defaultMessage: 'Field validation failed'
    },

    indemnityPeriodValidationMessage: {
        id: 'fnol.bi.sasria-business-interruption.indemnityPeriodValidationMessage',
        defaultMessage: 'must be an integer with no more than 10 digits'
    },

    sumInsuredValidationMessage: {
        id: 'fnol.bi.sasria-business-interruption.sumInsuredValidationMessage',
        defaultMessage: 'must be an integer with no more than 20 digits'
    },

    lossEstimateLessThan16Message: {
        id: 'fnol.bi.sasria-business-interruption.lossEstimateLessThan16Message',
        defaultMessage: 'can have no more than 16 digit to left of decimal point'
    },

    lossEstimateLessThan1ErrorMessage: {
        id: 'fnol.bi.sasria-business-interruption.lossEstimateLessThan1ErrorMessage',
        defaultMessage: 'Value of Loss Estimate cannot be less than R1.0'
    },

    passportNoValidationTitle: {
        id: 'fnol.bi.sasria-business-interruption.passportNoValidationTitle',
        defaultMessage: 'Passport Number validation has failed'
    },
    passportNoValidationMessage: {
        id: 'fnol.bi.sasria-business-interruption.passportNoValidationMessage.',
        defaultMessage: 'Passport Number must be less than 13 digits and aplha numeric with no spaces.'
    },
    idNoValidationTitle: {
        id: 'fnol.bi.sasria-business-interruption.idNoValidationTitle',
        defaultMessage: 'Identity Number validation has failed'
    },
    idNoValidationMessage: {
        id: 'fnol.bi.sasria-business-interruption.idNoValidationMessage.',
        defaultMessage: 'Identity Number must be 13 digit numeric number with no spaces(YYMMDDNNNNNNN).It is a mandatory field.'
    },

});
